module.exports = __webpack_public_path__ + "img/servicepro_login_dark.32a71449.png";